/**
 * @generated SignedSource<<3a5b794b45710df4e74007252af2f9d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ExecutionStatus = "ABORTED" | "FAILED" | "PENDING_REDRIVE" | "RUNNING" | "SUCCEEDED" | "TIMED_OUT" | "%future added value";
export type TopicStatus = "IDLE" | "RUNNING" | "%future added value";
export type TopicVisibility = "PRIVATE" | "PUBLIC" | "UNLISTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TopicList_topic$data = {
  readonly canTriggerIngestion: boolean;
  readonly episodeCount: number;
  readonly id: string;
  readonly isActive: boolean;
  readonly lastExecutionStartedAt: any | null | undefined;
  readonly lastExecutionStatus: ExecutionStatus | null | undefined;
  readonly lastIngestionAt: any | null | undefined;
  readonly name: string;
  readonly slug: string;
  readonly status: TopicStatus;
  readonly visibility: TopicVisibility;
  readonly " $fragmentType": "TopicList_topic";
};
export type TopicList_topic$key = {
  readonly " $data"?: TopicList_topic$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicList_topic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicList_topic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "episodeCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastIngestionAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastExecutionStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastExecutionStartedAt",
      "storageKey": null
    },
    {
      "alias": "canTriggerIngestion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "TRIGGER_INGESTION"
        }
      ],
      "kind": "ScalarField",
      "name": "canAct",
      "storageKey": "canAct(action:\"TRIGGER_INGESTION\")"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "1dcec765694a465230cb00cd31d6bcba";

export default node;
